module.exports = __webpack_public_path__ + "static/media/gcdef_10017.8abf5442.ico";